import ReauthenticateCode from './ReauthenticateCode'

export default function ReauthenticateRecoveryCodes (props) {
  return (
    <ReauthenticateCode>
      <p>Please enter a recovery code:</p>
    </ReauthenticateCode>
  )
}
